import { COMPONENT_TYPE, SharedServices } from "types/Service";



export const config = {
	// "host": {
	// 	"url": "https://farm-11.zero-farms.it:3223/api/"
	// },
	nats: {
		/** commentare in simulazione NATS */
		// host: "farm-11.zero-farms.it",
		// port: 8022,
		// enable_tls: false,
		/**********************************/
		publish: "zero.*.ii_command",
		subscribe: "zero.*.broadcast",

	},
	"cloud_nats": {
		"host": ["nats-01.zerofarms.it", "nats-02.zerofarms.it", "nats-03.zerofarms.it"],
		"port": 4433,
		"publish": "zero.*.ii_command",
		"subscribe": "zero.*.broadcast",
		"enable_tls": true
	},
	layout: {
		templates: [
			{ name: "rooms", title: "ROOMS" },
			{ name: "systems", title: "SYSTEMS" },
		]
	},
	components: [
		{
			name: "VBS 01",
			code: "VBS01",
			type: COMPONENT_TYPE.GROWUNIT,
			group: ["rooms"],
			options: {
				code: "ZERO021_VBS01_S024H04",
				grafana: [
					{
						"code": "adj-ph",
						"title": "ANDAMENTO PH",
						"url": "http://10.200.20.55:3000/d/bYHvaesHk/ffi_uta_dev?orgId=1&viewPanel=2&from=now-24h&to=now&var-UTA=%27FFI00_VCE_HV002%27&kiosk=1"
					}
				],
				adj: {
					showPlant: true,
					numProbes: 1,
					hideAlarms: true,
					version: "v2",
				},
			},
			subjects: [
				"ZERO021_VBS01_S024H04",
			],
		},
		{
			name: "VBS 02",
			code: "VBS02",
			type: COMPONENT_TYPE.GROWUNIT,
			group: ["rooms"],
			options: {
				code: "ZERO022_VBS02_S024H04",
			},
			subjects: [
				"ZERO022_VBS02_S024H04",
			],
		},
		{
			name: "VBS 03",
			code: "VBS03",
			type: COMPONENT_TYPE.GROWUNIT,
			group: ["rooms"],
			options: {
				code: "ZERO023_VBS03_S024H04",
			},
			subjects: [
				"ZERO023_VBS03_S024H04",
			],
		},
		{
			name: "VBS 04",
			code: "VBS04",
			type: COMPONENT_TYPE.GROWUNIT,
			group: ["rooms"],
			options: {
				code: "ZERO024_VBS04_S024H04",
			},
			subjects: [
				"ZERO024_VBS04_S024H04",
			],
		},
		{
			name: "VBS 05",
			code: "VBS05",
			type: COMPONENT_TYPE.GROWUNIT,
			group: ["rooms"],
			options: {
				code: "ZERO025_VBS05_S024H04",
			},
			subjects: [
				"ZERO025_VBS05_S024H04",
			],
		},
		{
			name: "GERMINATOR",
			code: "GERM",
			type: COMPONENT_TYPE.GERMINATOR,
			group: ["rooms"],
			subjects: [
				"ZR11_VBS_01",
			]
		},
		{
			type: COMPONENT_TYPE.HVAC,
			name: "GLOBAL HVAC",
			code: "HVAC",
			group: ["systems"],
			tags: ["GROWROOM", "GE PLC"],
			options: {
				uta_number: 3,
			},
			subjects: [
				"ZR11_VBS_00",
			]
		},
		{
			type: COMPONENT_TYPE.OSMOTIC_WATER,
			name: "OSMOTIC WATER",
			code: "OW",
			group: ["systems"],
			tags: ["OW PLC"],
			options: {
			},
			subjects: [
				"ZR11_VBS_00",
			]
		},
		{
			type: COMPONENT_TYPE.CO2,
			name: "CO2",
			code: "CO2",
			group: ["systems"],
			tags: [],
			options: {
			},
			subjects: [
				"ZR11_VBS_00",
			]
		},
		{
			name: "POWERS",
			code: "POWERS",
			hidden: true,
			type: COMPONENT_TYPE.POWERS,
			subjects: [
				"ZR11_VBS_00",
			]
		},
	]
}